// Texty výpisu kategórie a detailu značky — slovenské dvojča locale/cs/categoryPage.js.
import { plural } from '../plural.js';

export default {
  filterTitle: 'Filtrácia',
  clearAll: 'Vymazať všetko',
  availability: 'Dostupnosť',
  tags: 'Štítky',
  seoTitle: 'Všetko, čo potrebujete vedieť',
  seoBrand: (name) => 'O značke ' + name,
  seoAnchor: 'viac o výbere nižšie',

  topTitle: (name) => (name ? 'Top produkty v kategórii ' + name : 'Top produkty v kategórii'),
  topFlag: 'Najpredávanejšie #1',

  secMore: (n) => 'Zobraziť viac (' + n + ')',
  secLess: 'Zobraziť menej',

  perexMore: 'Zobraziť celý popis',
  perexLess: 'Zobraziť menej',

  noResultTitle: 'Zvolenému filtru nezodpovedá žiadny produkt',
  noResultText: 'Skúste rozšíriť cenové rozpätie alebo zrušiť niektorý z filtrov.',
  noResultCta: 'Zrušiť filtre',
  emptyTitle: 'V tejto kategórii teraz nič nemáme',
  emptyTextSub: 'Produkty sú zaradené v podkategóriách vyššie, vyberte si z nich.',
  emptyText: 'Skúste sa pozrieť do nadradenej sekcie alebo použite vyhľadávanie.',

  advice: {
    eyebrow: 'Poradňa Jipos',
    title: 'Neviete si rady s výberom?',
    text: 'Zavolajte nám alebo napíšte, poradíme s výberom aj príslušenstvom.',
    textNoPhone: 'Napíšte nám, poradíme s výberom aj príslušenstvom.',
    callLabel: 'Poradíme s výberom',
    storeLabel: 'Navštíviť predajňu',
    perkShipping: 'Doprava po celom Slovensku',
    perkReturn: 'Vrátenie tovaru do 14 dní',
    perkService: 'Servis náradia na predajni',
  },

  promo: {
    eyebrow: 'Zľavy',
    title: 'Náradie a technika v zľave',
    body: 'Všetky aktuálne zľavnené produkty prehľadne na jednom mieste.',
    cta: 'Zobraziť zľavy',
  },

  /** 1 produkt / 2–4 produkty / 5+ produktov */
  productsWord: (n) => plural(n, ['produkt', 'produkty', 'produktov']),
};
